import Vue from 'vue'
import OOP from './OOP'
import OOPTodaySC from './OOPTodaySC'
import OOPFrontPage from './OOPFrontPage'
import OOPToday from './OOPToday'
import OOPMatch from './OOPMatch'
import Draws from './Draws'
import Live from './Live'
import LiveHolder from './LiveHolder'
import LivePerStadium from './LivePerStadium'
import Results from './Results'
import ResultsDay from './ResultsDay'
import ResultsLatest from './ResultsLatest'
import PlayerOOP from './PlayerOOP'
import MatchDetail from './MatchDetail'
import FeaturedMatches from './FeaturedMatches'
import PlayerResults from './PlayerResults'
import PlayerLive from './PlayerLive'
import MatchSlide from './MatchSlide'
import DailyDrawSheet from './DailyDrawSheet'


if ( jQuery('#game').length > 0) {

    let app = new Vue({
        components: {
            'score-oop'             : OOP,
            'score-oop-today'       : OOPToday,
            'score-oop-today-sc'    : OOPTodaySC,
            'score-oop-front-page'  : OOPFrontPage,
            'score-oop-match'       : OOPMatch,
            'score-draws'           : Draws,
            'score-live'            : Live,
            'score-live-holder'     : LiveHolder,
            'score-live-stadium'    : LivePerStadium,
            'score-results'         : Results,
            'score-results-day'     : ResultsDay,
            'score-results-latest'  : ResultsLatest,
            'score-player-oop'      : PlayerOOP,
            'score-match'           : MatchDetail,
            'score-featured'        : FeaturedMatches,
            'score-player-matches'  : PlayerResults,
            'score-player-live'     : PlayerLive,
            'score-daily-draw-sheet': DailyDrawSheet,

        },
        el: '#game',
        data: {
        }
    })
}

const slides = document.getElementsByClassName( "match_slide" )

for ( var i = 0; i < slides.length; i ++ ) {
    console.log(slides[ i ].id)
    new Vue( {
         el: '#' + slides[ i ].id,
         components: {
            'score-slide'           : MatchSlide,
        },
        data: {
        }
     })
}
